import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';
import type { FailureReason } from '@Application/Security/TokenJourney/FailureReason';

export type InvitationAcceptanceFailedAction = {
	type: 'INVITATION_ACCEPTANCE_FAILED';
	payload: ExtractedMessages;
	reason: FailureReason;
	message: string;
};

export default (
	payload: ExtractedMessages,
	reason: FailureReason,
	message: string,
): InvitationAcceptanceFailedAction => ({
	type: 'INVITATION_ACCEPTANCE_FAILED',
	payload,
	reason,
	message,
});
